import React from "react";

function tickSVGnew() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 59 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_327_15693)">
        <path
          d="M48.9731 11.2256C50.9804 9.18183 54.3452 9.1666 56.4897 11.2305C58.4405 13.222 58.5002 16.3898 56.6685 18.4531L56.4849 18.6494L26.8979 48.7744C25.9018 49.7887 24.565 50.2499 23.2036 50.25C21.9272 50.25 20.6724 49.8444 19.6997 48.958L19.5083 48.7744L2.68896 31.6494C0.733568 29.6581 0.672946 26.4868 2.50635 24.4219L2.68896 24.2256C4.63982 22.2393 7.74041 22.177 9.76318 24.0391L9.95557 24.2256L22.7241 37.2256L23.0806 37.5889L23.437 37.2256L48.9731 11.2256Z"
          fill="#232323"
          stroke="#232323"
        />
      </g>
      <defs>
        <clipPath id="clip0_327_15693">
          <rect width="58.9286" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default tickSVGnew;
